import { Button, Stack } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";

interface UndoButtonProps {
  onClick: () => void;
  enableUndo: boolean;
}

export function UndoButton(props: UndoButtonProps) {
  const { onClick, enableUndo } = props;

  return (
    <Button
      onClick={() => onClick()}
      disabled={!enableUndo}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: { xs: 'center', md: 'space-between' },
        width: '100%',
        height: '30px',
        paddingX: '10px',
        backgroundColor: (theme) => theme.palette.axon.main,
        '&:hover': {
          backgroundColor: (theme) => theme.palette.axon.hover,
        },
        '&:disabled': {
          backgroundColor: '#C8CDD3',
        },
        borderRadius: '20px',
        textTransform: 'none'
      }}
    >
      <Typography
        noWrap
        variant="small"
        fontWeight="medium"
        className="text-primary-darkest"
      >
        ANSWER SUBMITTED. UNDO
      </Typography>
      {/* Only show ESC on md breakpoint and up */}
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        className="hidden md:flex text-neutral-200 opacity-70"
      >
        <Typography
          variant="small"
          fontWeight="medium"
          className="text-primary-darkest opacity-80"
        >
          (ESC.)
        </Typography>
      </Stack>
    </Button>
  );
}
